export const SURVEY_SOURCE_LANGUAGE = 'en';

export const SURVEY_TRANSLATION_LANGUAGES = [
  { label: 'English', nativeLabel: 'English', value: 'en' },
  { label: 'French', nativeLabel: 'Français', value: 'fr' },
  { label: 'German', nativeLabel: 'Deutsch', value: 'de' },
  { label: 'Spanish', nativeLabel: 'Español', value: 'es' },
  { label: 'Korean', nativeLabel: '한국어', value: 'ko' },
  { label: 'Turkish', nativeLabel: 'Türkçe', value: 'tr' },
  { label: 'Arabic', nativeLabel: 'العربية', value: 'ar' },
  { label: 'Russian', nativeLabel: 'Русский', value: 'ru' },
  { label: 'Kannada', nativeLabel: 'ಕನ್ನಡ', value: 'kn' },
];

export const SURVEY_TRANSLATION_LANGUAGE_LABELS = Object.fromEntries(
  SURVEY_TRANSLATION_LANGUAGES.map(({ label, value }) => [value, label])
);

export const SURVEY_TRANSLATION_NATIVE_LANGUAGE_LABELS = Object.fromEntries(
  SURVEY_TRANSLATION_LANGUAGES.map(({ nativeLabel, value }) => [value, nativeLabel])
);

export const LANGUAGE_SCREENER_SCREENER_LABEL = 'Preferred Language';

export const LANGUAGE_SCREENER_QUESTION_TEXT =
  'Choose your preferred language to answer this survey';

export const LANGUAGE_SCREENER_QUESTION_TEXT_TRANSLATIONS = {
  ar: 'اختر لغتك المفضلة للإجابة على هذا الاستبيان',
  de: 'Wählen Sie Ihre bevorzugte Sprache, um diese Umfrage zu beantworten',
  en: LANGUAGE_SCREENER_QUESTION_TEXT,
  es: 'Elija su idioma preferido para responder a esta encuesta',
  fr: 'Choisissez votre langue préférée pour répondre à ce sondage',
  kn: 'ಈ ಸಮೀಕ್ಷೆಗೆ ಉತ್ತರಿಸಲು ನಿಮ್ಮ ಆದ್ಯತೆಯ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  ko: '이 설문에 응답할 선호 언어를 선택하세요',
  ru: 'Выберите предпочитаемый язык для ответа на этот опрос',
  tr: 'Bu anketi yanıtlamak için tercih ettiğiniz dili seçin',
};

export const TRANSLATION_MODAL_MESSAGES = {
  fetchError: 'Unable to fetch translations. You can still enter them manually.',
  formattingMismatch: 'Formatting does not match original text',
  missingVariable: 'Variable {variable} is missing',
  relevanceWarning: 'This translation may not match the original question as it has been edited.',
};

// Hand-provided defaults; worth a localization review before release.
export const TRANSLATION_MODAL_MESSAGE_TRANSLATIONS = {
  fetchError: {
    ar: 'تعذّر جلب الترجمات. لا يزال بإمكانك إدخالها يدويًا.',
    de: 'Übersetzungen konnten nicht abgerufen werden. Sie können sie weiterhin manuell eingeben.',
    es: 'No se pudieron obtener las traducciones. Aún puede introducirlas manualmente.',
    fr: 'Impossible de récupérer les traductions. Vous pouvez toujours les saisir manuellement.',
    kn: 'ಅನುವಾದಗಳನ್ನು ಪಡೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ನೀವು ಇನ್ನೂ ಅವನ್ನು ಕೈಯಾರೆ ನಮೂದಿಸಬಹುದು.',
    ko: '번역을 가져올 수 없습니다. 직접 입력할 수 있습니다.',
    ru: 'Не удалось загрузить переводы. Вы можете ввести их вручную.',
    tr: 'Çeviriler alınamadı. Yine de manuel olarak girebilirsiniz.',
  },
  formattingMismatch: {
    ar: 'التنسيق لا يتطابق مع النص الأصلي',
    de: 'Die Formatierung stimmt nicht mit dem Originaltext überein',
    es: 'El formato no coincide con el texto original',
    fr: "La mise en forme ne correspond pas au texte d'origine",
    kn: 'ಸ್ವರೂಪವು ಮೂಲ ಪಠ್ಯದೊಂದಿಗೆ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ',
    ko: '서식이 원본 텍스트와 일치하지 않습니다',
    ru: 'Форматирование не соответствует исходному тексту',
    tr: 'Biçimlendirme orijinal metinle eşleşmiyor',
  },
  missingVariable: {
    ar: 'المتغير {variable} مفقود',
    de: 'Die Variable {variable} fehlt',
    es: 'Falta la variable {variable}',
    fr: 'La variable {variable} est manquante',
    kn: '{variable} ಚರ ಕಾಣೆಯಾಗಿದೆ',
    ko: '{variable} 변수가 누락되었습니다',
    ru: 'Переменная {variable} отсутствует',
    tr: '{variable} değişkeni eksik',
  },
  relevanceWarning: {
    ar: 'قد لا تتطابق هذه الترجمة مع السؤال الأصلي لأنه تم تعديله.',
    de: 'Diese Übersetzung stimmt möglicherweise nicht mit der ursprünglichen Frage überein, da diese bearbeitet wurde.',
    es: 'Es posible que esta traducción no coincida con la pregunta original, ya que se ha editado.',
    fr: "Cette traduction peut ne pas correspondre à la question d'origine, car celle-ci a été modifiée.",
    kn: 'ಮೂಲ ಪ್ರಶ್ನೆಯನ್ನು ಸಂಪಾದಿಸಿರುವುದರಿಂದ ಈ ಅನುವಾದವು ಅದಕ್ಕೆ ಹೊಂದಿಕೆಯಾಗದಿರಬಹುದು.',
    ko: '원본 질문이 수정되어 이 번역이 일치하지 않을 수 있습니다.',
    ru: 'Этот перевод может не соответствовать исходному вопросу, так как он был изменён.',
    tr: 'Orijinal soru düzenlendiği için bu çeviri eşleşmeyebilir.',
  },
};
